export enum StepStatus {
  Preview = 0,
  Active = 1,
  InProgress = 2,
  Complete = 3,
}
